import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus, vs } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { useThemeContext } from '../contexts/ThemeContext';
import { markdownComponents } from '../utils/markdown';

/**
 * Unified markdown renderer with syntax highlighting
 * Replaces 3 duplicate CodeComponent implementations
 */
function MarkdownRenderer({ content, className = '' }) {
  const { theme } = useThemeContext();

  // Custom code component with syntax highlighting
  const CodeComponent = ({ inline, className, children, ...props }) => {
    const match = /language-(\w+)/.exec(className || '');
    const language = match ? match[1] : '';

    if (inline) {
      return (
        <code className="inline-code" {...props}>
          {children}
        </code>
      );
    }

    return (
      <div className="code-block-wrapper">
        {language && <div className="code-language">{language}</div>}
        <SyntaxHighlighter
          style={theme === 'dark' ? vscDarkPlus : vs}
          language={language || 'text'}
          PreTag="div"
          {...props}
        >
          {String(children).replace(/\n$/, '')}
        </SyntaxHighlighter>
      </div>
    );
  };

  const components = {
    ...markdownComponents,
    code: CodeComponent
  };

  return (
    <ReactMarkdown
      className={className}
      remarkPlugins={[remarkGfm]}
      components={components}
    >
      {content}
    </ReactMarkdown>
  );
}

export default MarkdownRenderer;
